import React, { useEffect, useState } from 'react';

const teamMembers = [
  { name: 'Jonathan Greenberg, PhD', role: 'Multiple Principal Investigator', image: 'assets/jonathan-greenberg.jpg' },
  { name: 'Ana-Maria Vranceanu, PhD', role: 'Multiple Principal Investigator', image: 'assets/ana-maria-vranceanu.jpg' },
  { name: 'Jafar Bakhshaie, PhD', role: 'Co-Investigator / Biostatistician', image: 'assets/jafar-bakhshaie.jpg' },
  { name: 'Jeffry Shaefer, DMD, DDS', role: 'Co-Investigator', image: 'assets/jeffry-shaefer.jpg' },
  { name: 'Ronald Kulich, PhD', role: 'Co-Investigator', image: 'assets/ronald-kulich.jpg' },
  { name: 'Brenda Lovette, PhD', role: 'Instructor/ Clinician', image: 'assets/brenda-lovette.jpg' },
  { name: 'Kozbi Bayne-Cliff, BA', role: 'Study Coordinator', image: 'assets/kozbi-bayne.jpg' },
  { name: 'Hsinlin Thomas Cheng, MD, PhD', role: 'Other Significant Contributor', image: 'assets/hsinlin-cheng.jpg' },
  { name: 'Shuhan He, MD', role: 'Consultant', image: 'assets/shuhan-he.jpg'},
  { name: 'Valerie Jap, BS', role: 'Software Engineer', image: 'assets/valerie-jap.jpg'},
];

const TeamPage = () => {
  const [isMobile, setIsMobile] = useState(false);

  // Check for mobile screen size
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  useEffect(() => {
    document.body.classList.add('team-page-body');
    return () => {
      document.body.classList.remove('team-page-body');
    };
  }, []);

  return (
    <div className="google-landing-override ffw-typography" style={{ 
      minHeight: '100vh', 
      background: 'linear-gradient(180deg, #eef4ff 0%, #dce8ff 46%, #edf4ff 100%)', 
      width: '100%',
      position: 'relative'
    }}>
      {/* Header */}
      <header style={{ 
        padding: isMobile ? '12px 16px' : '16px 24px', 
        borderBottom: '1px solid #e8eaed',
        backgroundColor: '#f8fbff'
      }}>
        <div style={{ 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'space-between', 
          maxWidth: '1200px', 
          margin: '0 auto',
          flexDirection: isMobile ? 'column' : 'row',
          gap: isMobile ? '16px' : '0'
        }}>
          {!isMobile && (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <img src="/assets/FFWLOGOtransparent.png" alt="Face Forward Web" style={{ 
                height: '40px', 
                width: 'auto', 
                marginRight: '32px'
              }} />
            </div>
          )}
          
          <nav className="ffw-nav" style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: isMobile ? '20px' : '32px',
            flexWrap: 'wrap',
            justifyContent: isMobile ? 'center' : 'flex-end'
          }}>
            <a href="/" style={{ 
              fontSize: '14px', 
              color: '#5f6368', 
              textDecoration: 'none', 
              padding: '8px 0',
              borderBottom: '2px solid transparent',
              transition: 'all 0.2s ease',
              fontWeight: '500'
            }}
            onMouseEnter={(e) => {
              e.target.style.color = '#202124';
              e.target.style.borderBottomColor = '#4285f4';
            }}
            onMouseLeave={(e) => {
              e.target.style.color = '#5f6368';
              e.target.style.borderBottomColor = 'transparent';
            }}>Home</a>
            <a href="/team" style={{ 
              fontSize: '14px', 
              color: '#202124', 
              textDecoration: 'none', 
              padding: '8px 0',
              borderBottom: '2px solid #4285f4',
              transition: 'all 0.2s ease',
              fontWeight: '500'
            }}>Team</a>
            <a href="/support" style={{ 
              fontSize: '14px', 
              color: '#5f6368', 
              textDecoration: 'none', 
              padding: '8px 0',
              borderBottom: '2px solid transparent',
              transition: 'all 0.2s ease',
              fontWeight: '500'
            }}
            onMouseEnter={(e) => {
              e.target.style.color = '#202124';
              e.target.style.borderBottomColor = '#4285f4';
            }}
            onMouseLeave={(e) => {
              e.target.style.color = '#5f6368';
              e.target.style.borderBottomColor = 'transparent';
            }}>Support</a>
            <a href="/participate-flyer" style={{ 
              fontSize: '14px', 
              color: '#5f6368', 
              textDecoration: 'none', 
              padding: '8px 0',
              borderBottom: '2px solid transparent',
              transition: 'all 0.2s ease',
              fontWeight: '500'
            }}
            onMouseEnter={(e) => {
              e.target.style.color = '#202124';
              e.target.style.borderBottomColor = '#4285f4';
            }}
            onMouseLeave={(e) => {
              e.target.style.color = '#5f6368';
              e.target.style.borderBottomColor = 'transparent';
            }}>Participate/Refer</a>
            <a href="/login" style={{ 
              fontSize: '14px', 
              color: '#4285f4', 
              textDecoration: 'none', 
              padding: '8px 16px',
              border: '1px solid #4285f4',
              borderRadius: '50px',
              transition: 'all 0.2s ease',
              fontWeight: '500'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#4285f4';
              e.target.style.color = '#ffffff';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = 'transparent';
              e.target.style.color = '#4285f4';
            }}>Sign In</a>
          </nav>
        </div>
      </header>

      {/* Hero Section */}
      <section style={{ 
        padding: isMobile ? '64px 16px 48px' : '92px 24px 84px', 
        textAlign: 'center' 
      }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          {/* Mobile FFW Logo */}
          {isMobile && (
            <div style={{ 
              marginBottom: '32px', 
              display: 'flex', 
              justifyContent: 'center'
            }}>
              <img 
                src="/assets/FFWLOGOtransparent.png" 
                alt="Face Forward Web" 
                style={{ 
                  height: '80px', 
                  width: 'auto'
                }}
              />
            </div>
          )}

          <h1 style={{ 
            fontSize: isMobile ? '2.35rem' : '64px', 
            fontWeight: '400', 
            color: '#202124', 
            marginBottom: isMobile ? '12px' : '16px',
            fontFamily: 'Product Sans, Arial, sans-serif',
            lineHeight: '1.1',
            padding: isMobile ? '0 8px' : '0'
          }}>
            Meet the Team
          </h1>
          <p style={{ 
            fontSize: isMobile ? '16px' : '20px', 
            color: '#5f6368', 
            maxWidth: '800px', 
            margin: isMobile ? '0 auto 32px' : '0 auto 48px',
            lineHeight: '1.4',
            padding: isMobile ? '0 8px' : '0'
          }}>
            The dedicated specialists behind Face Forward Web, working to support patients with chronic orofacial pain
          </p>

          {/* Trust Logos - Mobile and Desktop */}
          {isMobile ? (
            /* Mobile: Vertical Stack */
            <div style={{ 
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '16px',
              marginBottom: '32px',
              padding: '20px',
              backgroundColor: '#f8f9fa',
              borderRadius: '12px',
              margin: '0 16px 32px 16px'
            }}>
              <img 
                src="/assets/harvardmedical_logo.png" 
                alt="Harvard Medical School" 
                style={{ 
                  height: '32px', 
                  width: 'auto'
                }}
              />
              <img 
                src="/assets/mgh_logo.png" 
                alt="Massachusetts General Hospital" 
                style={{ 
                  height: '32px', 
                  width: 'auto'
                }}
              />
              <img 
                src="/assets/CHOIRlogo.png" 
                alt="CHOIR" 
                style={{ 
                  height: '32px', 
                  width: 'auto'
                }}
              />
            </div>
          ) : (
            /* Desktop: Horizontal */
            <div style={{ 
              display: 'flex', 
              justifyContent: 'center', 
              alignItems: 'center', 
              gap: '32px',
              marginBottom: '48px',
              flexWrap: 'wrap'
            }}>
              <div style={{
                backgroundColor: '#f8f9fa',
                padding: '16px 24px',
                borderRadius: '8px',
                display: 'flex',
                alignItems: 'center',
                gap: '24px'
              }}>
                <img 
                  src="/assets/harvardmedical_logo.png" 
                  alt="Harvard Medical School" 
                  style={{ 
                    height: '40px', 
                    width: 'auto'
                  }}
                />
                <img 
                  src="/assets/mgh_logo.png" 
                  alt="Massachusetts General Hospital" 
                  style={{ 
                    height: '40px', 
                    width: 'auto'
                  }}
                />
                <img 
                  src="/assets/CHOIRlogo.png" 
                  alt="CHOIR" 
                  style={{ 
                    height: '40px', 
                    width: 'auto'
                  }}
                />
              </div>
            </div>
          )}
        </div>
      </section>

      {/* Team Grid Section */}
      <section style={{ 
        padding: isMobile ? '32px 16px 60px' : '40px 24px 80px' 
      }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(300px, 1fr))', 
            gap: isMobile ? '24px' : '32px',
            alignItems: 'stretch'
          }}>
            {teamMembers.map((member, index) => (
              <div key={index} className="ffw-panel" style={{
                backgroundColor: '#ffffff',
                borderRadius: '16px',
                padding: '0',
                overflow: 'hidden',
                border: '1px solid #d9e3f1',
                transition: 'all 0.3s ease',
                cursor: 'pointer',
                height: '100%',
                display: 'flex',
                flexDirection: isMobile ? 'row' : 'column' // Mobile: horizontal layout
              }}
              onMouseEnter={(e) => {
                if (!isMobile) {
                  e.currentTarget.style.transform = 'translateY(-4px)';
                  e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.1)';
                }
              }}
              onMouseLeave={(e) => {
                if (!isMobile) {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                }
              }}>
                <div style={{ 
                  width: isMobile ? '120px' : '100%', 
                  height: isMobile ? '120px' : '280px',
                  backgroundColor: '#f8f9fa',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  overflow: 'hidden',
                  position: 'relative',
                  flexShrink: 0 // Prevent shrinking on mobile
                }}>
                  <img 
                    src={member.image} 
                    alt={member.name} 
                    style={{ 
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      objectPosition: isMobile ? 'center center' : // Mobile: center the image
                        (member.name === 'Jafar Bakhshaie, PhD' ? 'center 1%' :
                         member.name === 'Brenda Lovette, PhD' ? 'center 10%' :
                         member.name === 'Kozbi Bayne-Cliff, BA' ? 'center 40%' :
                         'center 20%') // Desktop: custom positioning
                    }}
                    onError={(e) => {
                      // Fallback for missing images
                      e.target.style.display = 'none';
                      e.target.parentElement.innerHTML = `
                        <div style="
                          width: ${isMobile ? '60px' : '80px'}; 
                          height: ${isMobile ? '60px' : '80px'}; 
                          background-color: #4285f4; 
                          border-radius: 50%; 
                          display: flex; 
                          align-items: center; 
                          justify-content: center; 
                          color: white; 
                          font-size: ${isMobile ? '20px' : '24px'}; 
                          font-weight: 500;
                        ">
                          ${member.name.charAt(0)}
                        </div>
                      `;
                    }}
                  />
                </div>
                <div style={{ 
                  padding: isMobile ? '20px' : '24px',
                  flex: 1,
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: isMobile ? 'center' : 'flex-start' // Mobile: center content
                }}>
                  <h3 style={{ 
                    fontSize: isMobile ? '16px' : '18px', 
                    fontWeight: '500', 
                    color: '#202124', 
                    marginBottom: '8px',
                    fontFamily: 'Product Sans, Arial, sans-serif',
                    lineHeight: '1.3',
                    margin: '0 0 8px 0'
                  }}>
                    {member.name}
                  </h3>
                  <p style={{ 
                    fontSize: isMobile ? '13px' : '14px', 
                    color: '#5f6368', 
                    marginBottom: '16px',
                    lineHeight: '1.5',
                    margin: '0'
                  }}>
                    {member.role}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>


      {/* Footer */}
      <footer style={{ 
        borderTop: 'none', 
        padding: isMobile ? '32px 16px' : '48px 24px',
        backgroundColor: 'transparent'
      }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(auto-fit, minmax(200px, 1fr))', 
            gap: isMobile ? '24px' : '32px'
          }}>
            <div>
             
            </div>
          </div>
          
          <div style={{ 
            marginTop: isMobile ? '24px' : '32px', 
            paddingTop: isMobile ? '16px' : '24px', 
            borderTop: 'none', 
            textAlign: 'center' 
          }}>
            <p style={{ 
              fontSize: isMobile ? '11px' : '12px', 
              color: '#5f6368',
              margin: 0
            }}>
              © 2025 Face Forward Web. Developed by Harvard Medical School and Massachusetts General Hospital.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default TeamPage;
